import { memo } from 'react';

import { useTabsLogic } from './tabs.hook';
import type { TTabsConfig } from './tabs.types';
import * as S from './tabs.styles';

const Tabs = memo((props: TTabsConfig) => {
	const { refTitleContent, sliderCss, tabItems, isEmpty } = useTabsLogic(props);

	if (isEmpty) return null;

	return (
		<S.TitleContent ref={refTitleContent}>
			{tabItems.map((tab) => (
				<S.Title customStyle={tab.resolvedStyle} active={tab.active} key={`tab-label-${tab.title}`}>
					<button type="button" onClick={tab.clickAction ? () => tab.clickAction!(tab.index) : undefined}>
						{tab.title}
						{tab.unreadChats > 0 && <S.MessageCounter>{tab.unreadChatsCounter}</S.MessageCounter>}
					</button>
				</S.Title>
			))}
			<S.Slider data-testid="slider" data-qa="slider" style={sliderCss} />
		</S.TitleContent>
	);
});

Tabs.displayName = 'Tabs';
export { Tabs };
